import React from "react";
import Icon from "../../../../../common/components/Icon/Icon";

interface EmptyStateProps {
  iconName: string;
  title: string;
  message: string;
  buttonText: string;
  buttonUrl: string;
  /** Optional extra content to render below the button (e.g. Saved For Later list) */
  children?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  iconName,
  title,
  message,
  buttonText,
  buttonUrl,
  children,
}) => {
  return (
    <div className="empty-state">
      <Icon iconName={iconName} className="empty-state__icon" />
      <h2 className="empty-state__title">{title}</h2>
      <p className="empty-state__message">{message}</p>
      <a href={buttonUrl} className="empty-state__button">
        {buttonText}
      </a>
      {children && <div className="empty-state__extra">{children}</div>}
    </div>
  );
};

export default EmptyState;
